import { cn } from "~/lib/cn";

interface KbdProps {
    children: React.ReactNode;
    className?: string;
}

/**
 * Keyboard hint component. Renders a small subtle key cap. Pairs naturally
 * with command-bar items, menu items, and tooltips: "⌘K", "⏎", "/".
 */
export function Kbd({ children, className }: KbdProps): React.ReactElement {
    return <span className={cn("kbd", className)}>{children}</span>;
}
